<template>
  <v-main>
    <AppBar/>
    <v-layout fill-height column>
      <v-container flex-fill fluid class="pt-0">
        <ul class="list-group">
          <li class="d-flex no-arrow">
            푸쉬 알림
            <v-spacer />
            <v-switch
                v-model="pushRecvYn"
                :true-value="'Y'"
                :false-value="'N'"
                inset
                :ripple="false"
                class="switch"
                hide-details="false"
                @change="setrecvYn"
            />
          </li>
          <li class="d-flex no-arrow">
            야간 알림
            <v-spacer />
            <v-switch
                v-model="nightTimeRecvYn"
                :true-value="'Y'"
                :false-value="'N'"
                inset
                :ripple="false"
                class="switch"
                hide-details="false"
                @change="setrecvYn"
            />
          </li>
        </ul>
      </v-container>
    </v-layout>
  </v-main>
</template>
<script>
import store from "@/store";
import {mixinAuth} from "@/mixins";

export default {
  data: () => ({
    pushRecvYn: 'N',
    nightTimeRecvYn: 'N'
  }),
  mixins: [mixinAuth],
  created() {

  },
  async mounted() {
    this.initRecvYn()
  },
  methods: {
    initRecvYn() {
      this.pushRecvYn = this.memberInfo.pushRecvYn;
      this.nightTimeRecvYn = this.memberInfo.nightTimeRecvYn;
    },
    async setrecvYn() {
      let param = {
        pushRecvYn: this.pushRecvYn === 'Y' ? 'Y' : 'N',
        nightTimeRecvYn: this.nightTimeRecvYn === 'Y' ? 'Y' : 'N'
      }
      await store.dispatch('setRecvYn', this.$_payload('inData', param))
        .then(res => {
          if (res.success) {
            store.commit('setMemberInfo', param)
          } else {
            console.log(res.msg);
          }
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
        })
    },
  },

}
</script>
<style lang="scss" scoped>
.v-input--selection-controls::v-deep {
  margin-top: 0;
  padding-top: 0;

  .v-input--selection-controls__input {
    margin-right: 0;
    width: 42px;
  }
}

.v-input--switch.v-input--is-dirty::v-deep .v-input--switch__thumb {
  transform: translate(16px, 0) !important;
}
</style>
